angular.module('rjmNg.directives').directive "columnInputManager", [
  () ->
    restrict: "E"
    templateUrl: "directive.columnInputManager.html"
    replace: false
    controllerAs: "view"
    bindToController: true
    scope:
      columnInputs: "="
      table: "="
    controller: [
      () ->

        view = @

        view.addColumnInput = () ->
          view.columnInputs ?= []
          colInput =
            inputId: view.columnInputs.length
            column: null
            table: view.table
          view.columnInputs.push(colInput)

        view.removeColumnInput = (index) ->
          view.columnInputs.splice(index, 1)

        @$onInit = () ->
          if view.columnInputs?.length is 0
            view.addColumnInput()

        return view
    ]
]
